module.exports = __webpack_public_path__ + "img/music-player-stop-circle.5f17bbe9.svg";